import React from "react";
import {
  FaInfoCircle,
  FaMapMarkedAlt,
  FaPencilAlt,
  FaArrowLeft,
  // FaHome,
} from "react-icons/fa";
import { Link, useHistory, useLocation, useRouteMatch } from "react-router-dom";
import styles from "./appNav.module.css";
import markerIcon from "../../img/myth-marker_25x32.png";

export default function AppNav({ myths, onMythSelect, onShowAll }) {
  let history = useHistory();

  const showingMyth = useRouteMatch("/explorer/:id");

  const onMythClick = (myth) => {
    onMythSelect(myth);
    history.push("/");
  };

  return (
    <>
      {showingMyth && (
        <Link to="/map" className={styles.homeButt}>
          <FaArrowLeft />
        </Link>
      )}

      <nav className={styles.appNavSmall}>
        <NavButton to="/map" alsoMatch="/">
          <FaMapMarkedAlt />
        </NavButton>

        <NavButton to="/maker">
          <FaPencilAlt />
        </NavButton>

        <NavButton to="/about">
          <FaInfoCircle />
        </NavButton>
      </nav>

      {!showingMyth && (
        <>
          <nav className={styles.appNav}>
            <h1 className={styles.title}>
              ULVERSTON <br />
              Myth Mapper
            </h1>

            <h2>KEY:</h2>

            {/* <NavButton to="/">
              <FaHome />
              Home
            </NavButton> */}

            <NavButton to="/about">
              <FaInfoCircle />
              About
            </NavButton>

            <NavButton to="/maker">
              <FaPencilAlt />
              Maker
            </NavButton>

            {/* <NavButton to="/map" alsoMatch="/">
              <FaMapMarkedAlt />
              Map
            </NavButton> */}

            <h2>MYTHS:</h2>

            <button onClick={onShowAll} className={styles.mythButton}>
              <FaMapMarkedAlt /> Show ALL
            </button>

            {myths.map((myth) => (
              <button
                key={myth.id}
                onClick={() => onMythClick(myth)}
                className={styles.mythButton}
              >
                <img src={markerIcon} height={32} alt="myth icon" />{" "}
                {myth.title}
              </button>
            ))}
          </nav>
        </>
      )}
    </>
  );
}

const NavButton = ({ children, to, alsoMatch }) => {
  let history = useHistory();
  const location = useLocation();

  let isActive = location.pathname === to;
  if (!isActive && alsoMatch) {
    isActive = location.pathname === alsoMatch;
  }

  function handleClick() {
    if (isActive) {
      history.push("/map");
    } else {
      history.push(to);
    }
  }

  const classes = `${styles.navButt} ${isActive && styles.navSelected}`;

  return (
    <button className={classes} onClick={handleClick}>
      {children}
    </button>
  );
};
